import React from 'react'

const stripHTMLTags = str => str.replace(/<[^>]*>/g, '');

function limitString(text, maxLength) {
  let limitedText = stripHTMLTags(text).slice(0, maxLength);

  return "<p>" + limitedText + "...</p>"
}

function slug(name) {
  let slug = name.replaceAll(' ', '-')

  return slug.toLowerCase()
}

const GlossaryLink = ({ name, id }) => {
  return <a href={"/it-glossary/" + id + "-" + slug(name)}>{name}</a>
}

const Entry = ({ id, name, description, categoryName, relatedEntries = [], similarEntries = [], links = [], linkLabels = [] }) => {
  return <div className='entry'>
    <div className='with-padding'>
      {!id &&
        <h1 className='header-primary text-gradient-dark'>
          {name}
        </h1>
      }

      {id &&
        <h1 className='header-primary text-gradient-dark'>
          <a href={`/it-glossary/${id}-${slug(name)}`}>{name}</a>
        </h1>
      }
      <div className='category'>{categoryName}</div>
      <div className='description' dangerouslySetInnerHTML={{ __html: id ? limitString(description, 310) : description }} />
      {id &&
        <a href={`/it-glossary/${id}-${slug(name)}`} className="more-link">See more</a>
      }

      {!id &&
        <a href='#' onClick={() => { history.back(); }} className="back-link">Back</a>
      }
    </div>
    <div className='keywords'>

      {(relatedEntries.length > 0 || similarEntries.length > 0) &&
        <><div className='left-panel'>
          <div className='title'>
            Check also
          </div>

          <div className='content'>
            {relatedEntries.map((keyword) => <div key={'content-${keyword.name}'} >{GlossaryLink({ name: keyword.name, id: keyword.id })}</div>)}

            {similarEntries.map((keyword) =>
              <div key={'similar-content-${keyword.name}'}>{GlossaryLink({ name: keyword.name, id: keyword.id })}</div>
            )}
          </div>
        </div>
        </>
      }

    </div>

    <div className='resources with-padding'>
      {links.length > 0 &&
        <>
          <div className='title'>Useful resources</div>
          <div className='links'>
            {links[0].split("\r\n").map((link, index) => <p><a target="_blank" href={link} >{linkLabels[index]}</a></p>)}
          </div>
        </>
      }
    </div>

  </div >
}

export default Entry
